import {Component, OnDestroy, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {AuthService} from '../../../../../services/auth.service';
import {RegistryService} from '../../../services/registry.service';
import {Customer} from '../../../models/CustomerInfo/Customer';
import {UserService} from '../../../services/user.service';

@Component({
    selector: 'app-checkout-customer-details',
    templateUrl: './checkout-customer-details.component.html',
    styleUrls: ['./checkout-customer-details.component.css']
})
export class CheckoutCustomerDetailsComponent implements OnInit, OnDestroy {
    customer_type = null;
    customer: Customer;
    status = null;

    userLoggedEvent;
    customerLoadedEvent;
    userLoggedOutEvent;

    constructor(private registry: RegistryService, private authService: AuthService) {
        this.userLoggedEvent = this.authService.UserLoggedInEvent$.subscribe(customer => {

            this.status = 'loggedin';
            this.customer = customer;

        });

        this.userLoggedOutEvent = this.authService.UserLoggedOutEvent$.subscribe(() => {

            this.status = null;
            this.customer = null;

        });

        this.customerLoadedEvent = this.registry.CustomerLoadedEvent$.subscribe(customer => {

            this.status = 'loggedin';
            this.customer = customer;

        });


    }

    ngOnDestroy(): void {

    }

    ngOnInit(): void {
        if (this.registry.customer != null) {
            this.customer = this.registry.customer;
            this.status = 'loggedin';
        }


    }

    setCheckoutCustomerType(customer_type) {

        this.customer_type = customer_type;

    }

    reset() {

    }


}
